var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69815 0.347197L51.8908 19.9928C53.6477 20.6423 54.2866 22.5906 52.5297 23.5648L41.8287 29.8968L57.6406 45.9706C58.1198 46.4576 58.1198 47.2694 57.6406 47.7565L46.9396 58.6347C46.4605 59.1218 45.6619 59.1218 45.1827 58.6347L29.3708 42.561L23.1419 53.4392C22.0238 55.2251 20.267 54.738 19.6281 52.7897L0.302406 2.94497C-0.176744 1.80845 -0.0170272 0.996643 0.302406 0.509561C0.781555 -0.139882 1.58014 -0.139885 2.69815 0.347197Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.113153680e7deb422e97b3054b5fcdfa.svg";
export { ForwardRef as ReactComponent };